module.exports = __webpack_public_path__ + "static/mid-4dfd7d5c8b80f35c3ad931c4ef7c174f.png";